export default {
  translations: {
    CHANGE_PASSWORD_TITLE: "Alterar senha!",
    CHANGE_PASSWORD_DESCRIPTION:
      "Para alterar sua senha, preencha os campos abaixo:",
    CHANGE_PASSWORD_BAYER_TEXT:
      "Em caso de dúvida ou problemas na plataforma, por favor, entre em contato conosco pelo 0800 7021 241 ou pelo e-mail sac@bayer.com",
    PASSWORD_LABEL: "Defina sua nova senha",
    PASSWORD_CONFIRM_LABEL: "Confirme a sua nova senha",
    PASSWORD_BUTTON_TEXT: "DEFINIR NOVA SENHA",
    PASSWORD_ERROR_TEXT:
      "Sua nova senha DEVE conter: mínimo de 1 número, mínimo de 1 letra maiúscula, mínimo de 8 caracteres, mínimo de 1 letra minúscula, mínimo de 1 carácter especial (exemplos: @,!,#,*). Sua nova senha NÃO pode conter: sequências de três ou mais caracteres repetidos",
    PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MUST_CONTAIN: "Sua nova senha DEVE conter:",
    PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_NUMBER: "Mínimo de 1 número",
    PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_CAPITAL_LETTER: "Mínimo de 1 letra maiúscula",
    PASSWORD_ERROR_TEXT_RULE_MINIMUM_PASSWORD_LENGTH: "Mínimo de 8 caracteres",
    PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_LOWERCASE_LETTER: "Mínimo de 1 letra minúscula",
    PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_SPECIAL_CHARACTERS: "Mínimo de 1 carácter especial (Exemplos: @,!,#,*)",
    PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MAY_NOT_CONTAIN: "Sua nova senha NÃO pode conter:",
    PASSWORD_ERROR_TEXT_RULE_SEQUENCES_OF_X_OR_MORE_REPEATED_CHARACTERS: "Sequências de três ou mais caracteres repetidos",
    PASSWORD_DIFF: "As senhas não são iguais!",
    PASSWORD_CHANGE_SUCCESS: "Senha alterada com sucesso!",
    PASSWORD_CHANGE_SUCCESS_DESCRIPTION:
      "Você já pode acessar o site e o aplicativo do Universo Médico utilizando sua nova senha.",
    PASSWORD_CHANGE_ERROR_DESCRIPTION:
      "Infelizmente, sua alteração de senha não foi concluída. Por favor, tente novamente.",
    PASSWORD_CHANGE_ERROR: "Algo deu errado!",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/locales/pt.js